import React, { PureComponent } from 'react';
import { NavLink } from 'react-router-dom';

import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';

import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import { isFutureDate, stableSort, getSorting, insertIf } from '../Common/helpers';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';

import './style.css';

class AppointmentsTable extends PureComponent {
    state = {
        order:'asc'
        , orderBy:'HoursAppointment'
        , page:0
        , openModal:false
    };

    tableHeadClone = React.createRef();
    tableHeadRef = React.createRef();

    componentDidUpdate(){
    }

    deleteRow = (appointmentId) => {
        if(window.confirm("Tem a certeza que quer apagar esta marcação?")){
            this.setState({loading:true});
            fetch(API + 'deleteappointment&appointmentid=' + appointmentId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message, openModal: true, loading:false });
            });
        }
    }

    toggleConfirmedAppointment = (e) => {
        const el = document.getElementById(e.target.id);
        
        if(e.target.checked){
            fetch(API + "setconfirmedappointment&appointmentid=" + e.target.dataset.appid + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                if(result !== null && result.shortmsg === "OK")
                el.closest(".tableRow").classList.add("successBorder");
            });
        }else{
            fetch(API + "unsetconfirmedappointment&appointmentid=" + e.target.dataset.appid + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                if(result !== null && result.shortmsg === "OK")
                el.closest(".tableRow").classList.remove("successBorder");
            });
        }
    }

    openModal = (textObj) => {
        this.setState({ returnTitle: textObj.title, returnText: textObj.text , openModal: true });
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        this.props.reloadTable(null);
        //window.location.reload();
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.props.handleChangeRowsPerPage(event.target.value);
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    render() {
        const { isAdmin, loginData, staffName } = this.props;
        const appointments = this.props.fetchData !== null ? this.props.fetchData : []
              , appointmentDate = this.props.selectedDate
              , loadingClass = this.state.loading ? " ajaxLoading" : ""
              , { order, orderBy, page } = this.state
              , rowsPerPage = this.props.rowsPerPage
              , headerRows = [
                  { id: 'StoreName', active: true, numeric: false, label: 'Loja' },
                  { id: 'HoursAppointment', numeric: false, label: 'Horas' },
                  { id: 'ClientFullName', numeric: false, label: 'Cliente' },
                  ...insertIf(!staffName, { id: 'StaffFullName', numeric: false, label: 'Funcionário' }),
                  { id: 'Treatment', numeric: false, label: 'Tratamento' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        return (
            <div className="tableHolder">
                <Table className={"responsiveTable customTable originalTable" + loadingClass}>
                    <TableHead ref={this.tableHeadRef}>
                        <TableRow className="tableRow tableHeader">
                            <TableCell className="tableCell" colSpan="6"><h2 className="bigHeading">Marcações para {staffName}{this.props.dateName}</h2></TableCell>
                        </TableRow>
                    </TableHead>
                    <EnhancedTableHead
                        className="tableRow tableHeader"
                        headerRows={headerRows}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={this.handleRequestSort}
                        rowCount={appointments.length}>
                    </EnhancedTableHead>
                    <TableBody>
                        {appointments instanceof Array && stableSort(appointments, getSorting(order, orderBy))
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((appointment, index) =>
                        <TableRow key={appointment.Id + "_" + index} className={"tableRow" + (appointment.Confirmed === "1" ? " successBorder" : "")} ref={"appointmentId_" + appointment.Id}>
                            <TableCell data-title="Loja" className="tableCell"><div className="smallColorDiv" style={{backgroundColor: appointment.StoreColor}}></div> {appointment.StoreShortname}</TableCell>
                            <TableCell data-title="Horas" className="tableCell">{appointment.HoursAppointment.slice(0, -3)}</TableCell>
                            <TableCell data-title="Cliente" className="tableCell">
                                {appointment.ClientId &&
                                    <Tooltip
                                        title={appointment.CId + " - " + appointment.ClientFirstName + " " + appointment.ClientLastName + " (" + appointment.ClientCellPhone + ")"}
                                        enterDelay={200}>
                                        <span><NavLink to={"/Clients/"+appointment.ClientId}>{appointment.ClientFirstName} {appointment.ClientLastName}</NavLink></span>
                                    </Tooltip>
                                }
                                {
                                    appointment.ClientId && appointment.ClientGlobalNotes && loginData.profile.Clients && loginData.profile.Clients.globalNotes &&
                                    <Tooltip
                                        title={appointment.ClientGlobalNotes}
                                        enterDelay={200}>
                                        <span><button className="simpleBtn danger globalNotesWarning" onClick={() => this.openModal({ title: "Notas do Cliente", text: appointment.ClientGlobalNotes })}><i className="far fa-sticky-note fa-2x"></i></button></span>
                                    </Tooltip>
                                }
                            </TableCell>
                            {   !staffName &&
                                <TableCell data-title="Funcionário" className="tableCell">
                                    <Tooltip
                                        title={appointment.SId+" - "+appointment.StaffFirstName+" "+appointment.StaffLastName}
                                        enterDelay={200}>
                                        <span><NavLink to={"/Staff/"+appointment.StaffId}>{appointment.StaffFirstName} {appointment.StaffLastName}</NavLink></span>
                                    </Tooltip>
                                </TableCell>
                            }
                            <TableCell data-title="Tratamento" className="tableCell">{appointment.Treatment}</TableCell>
                            <TableCell data-title="Ações" className="tableCell actions actionsBig" data-row-id={appointment.Id}>
                                {appointment.ClientId ?
                                    (isAdmin || loginData.profile.Appointments.permission === 1) && isFutureDate(new Date(appointment.DateAppointment + " " + appointment.HoursAppointment)) ?    
                                        <span>                                
                                            <Tooltip
                                                title={"Confirmar marcação"}
                                                enterDelay={200}>
                                                <span><input type="checkbox" id={"confirm_" + appointment.Id} onChange={this.toggleConfirmedAppointment} data-appid={appointment.Id} defaultChecked={appointment.Confirmed === "1" ? true : false} /></span>
                                            </Tooltip>                     
                                            <Tooltip
                                                title={"Editar marcação"}
                                                enterDelay={200}>
                                                <span><NavLink className="actionButton warning" to={{pathname:"/Appointments/"+appointment.Id, storeId:appointment.StoreId, staffId:this.props.staffId}}><i className="fa fa-pencil-alt"></i></NavLink></span>
                                            </Tooltip>
                                        </span>
                                        :                                  
                                        <Tooltip
                                            title={"Ver marcação"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={{pathname:"/Appointments/"+appointment.Id, blockDates:true, storeId:appointment.StoreId, staffId:this.props.staffId, appDate:appointmentDate, appHour:appointment.HoursAppointment.slice(0, -3)}}><i className="fa fa-eye"></i></NavLink></span>
                                        </Tooltip>
                                    :
                                    (isAdmin || loginData.profile.Appointments.ADD) && appointment.IsWorking==="1" && isFutureDate(new Date(appointmentDate + " " + appointment.HoursAppointment)) &&                                  
                                        <Tooltip
                                            title={"Adicionar marcação"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={{pathname:"/Appointments/New", blockDates:true, storeId:appointment.StoreId, staffId:this.props.staffId, appDate:appointmentDate, appHour:appointment.HoursAppointment}}><i className="fa fa-plus"></i></NavLink></span>
                                        </Tooltip>
                                }
                                {(isAdmin || loginData.profile.Appointments.DEL) && appointment.ClientId &&
                                    <Tooltip
                                        title={"Eliminar marcação"}
                                        enterDelay={200}>
                                        <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteRow(appointment.Id)}><i className="fa fa-times"></i></button></span>
                                    </Tooltip>
                                }
                            </TableCell>
                        </TableRow>
                        )}
                    </TableBody>
                </Table>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[15, 30]}
                            component="div"
                            count={appointments.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{'aria-label': 'Página anterior',}}
                            nextIconButtonProps={{'aria-label': 'Próxima página'}}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default AppointmentsTable;
